import { createFileRoute } from "@tanstack/react-router"
import DataDeletionPage from "~/components/DataDeletionPage"
import CustomHead from "~/components/SEOHead/CustomHead"
import { api } from "~/utils/api"

function DeletionRequestPage() {
  const ctx = api.useContext()

  const user = ctx.users.getUserWithTeam.getData()

  if (!user) {
    return null
  }

  return (
    <>
      <CustomHead />

      <DataDeletionPage user={user} />
    </>
  )
}

export const Route = createFileRoute("/deletion-request")({
  component: DeletionRequestPage,
})
